// 民宿管理
export default [
  {
    path: '/minsusManage',
    component: () => import('../pages/homestay/homestayNew/hotelManage.vue'),
    name: 'minsusManage',
    title: '民宿管理',
    meta: {
      title: '民宿管理',
    },
  },
  {
    path: '/homestayRoomConfigSetting',
    component: () => import('../pages/homestay/homestayNew/roomConfigSetting.vue'),
    name: 'homestayRoomConfigSetting',
    title: '民宿房间配置',
    meta: {
      title: '民宿房间配置',
    },
  },
  {
    path: '/homestayRoomTypeManage',
    component: () => import('../pages/homestay/homestayNew/roomTypeManage.vue'),
    name: 'homestayRoomTypeManage',
    title: '民宿房型管理',
    meta: {
      title: '民宿房型管理',
    },
  },
  {
    path: '/homestayPriceConfigSetting',
    component: () => import('../pages/homestay/homestayNew/priceConfigSetting.vue'),
    name: 'homestayPriceConfigSetting',
    title: '民宿售价设置',
    meta: {
      title: '民宿售价设置',
    },
  },
  {
    path: '/minsuFacilities',
    component: () => import('../pages/homestay/homestayNew/facilitiesManage.vue'),
    name: 'minsuFacilities',
    title: '民宿设施管理',
    meta: {
      title: '民宿设施管理',
    },
  },
  {
    path: '/hotelFacilitiesCategory',
    component: () => import('../pages/homestay/homestayNew/facilitiesManage.vue'),
    name: 'hotelFacilitiesCategory',
    title: '民宿设施类型',
    meta: {
      title: '民宿设施类型',
    },
  },
  {
    path: '/hotelBasicAttribute',
    component: () => import('../pages/homestay/homestayNew/baseAttributeManage.vue'),
    name: 'hotelBasicAttribute',
    title: '基本属性',
    meta: {
      title: '基本属性',
    },
  },
  {
    path: '/getInfo',
    component: () => import('../pages/homestay/homestayNew/hotelOrderManage.vue'),
    name: 'getInfo',
    title: '订单管理',
    meta: {
      title: '订单管理',
    },
  },
  {
    path: '/minsuCheckin',
    component: () => import('../pages/homestay/homestayNew/occupancyMange.vue'),
    name: 'minsuCheckin',
    title: '入住办理',
    meta: {
      title: '入住办理',
    },
  },
  {
    path: '/homestayOccupancyMange',
    component: () => import('../pages/homestay/homestayNew/occupancyMange.vue'),
    name: 'homestayOccupancyMange',
    title: '入住办理',
    meta: {
      title: '入住办理',
    },
  },
  {
    path: '/homestayLeaveHotel',
    component: () => import('../pages/homestay/homestayNew/leaveHotel.vue'),
    name: 'homestayLeaveHotel',
    title: '离店办理',
    meta: {
      title: '离店办理',
    },
  },
  {
    path: '/appraiseManage',
    component: () => import('../pages/homestay/appraiseManage.vue'),
    name: 'appraiseManage',
    title: '评价管理',
    meta: {
      title: '评价管理',
    },
  },
  {
    path: '/minsuContent',
    component: () => import('../pages/homestay/minsuContent.vue'),
    name: 'minsuContent',
    title: '民宿概况',
    meta: {
      title: '民宿概况',
    },
  },
  {
    path: '/minsuReco',
    component: () => import('../pages/homestay/minsuReco.vue'),
    name: 'minsuReco',
    title: '民宿推荐',
    meta: {
      title: '民宿推荐',
    },
  },
]
